import React from 'react';
import { Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';
import { routes as originRoutes } from '../../configs/routes';
import { SessionContext } from './MainContainer';
import ParentContainerRoute from './ParentContainerRoute';
import find from 'lodash/find';
import { USER_CONFIG } from '../../configs/AppConfig';
import { getCachedRoutePath } from '../../state/route/routeSelector';
import { connect } from 'react-redux';

const UnauthenticatedRoute = props => {
  const { session: { isAuthenticated, user }, routes, cachedRoute } = props;
  if (!isAuthenticated) {
    const customRoutes = routes.filter(el => el.layoutId.startsWith(originRoutes.unauthorizedRoutes.name, 0));
    return <ParentContainerRoute routes={customRoutes} />;
  } else {
    const userConfig = user && find(USER_CONFIG, { roleLevel: user.roleLevel });

    if (cachedRoute.pathname) {
      return <Redirect to={{ pathname: cachedRoute.pathname, search: cachedRoute.search }} push/>;
    }

    if (userConfig) {
      return <Redirect to={userConfig.landingPage} push/>;
    }

    return <Redirect to={originRoutes.authorizedRoutes.routes[0].path} push/>;
  }
};

UnauthenticatedRoute.propsType = {
  session: PropTypes.object.isRequired,
  routes: PropTypes.array.isRequired,
  cachedRoute: PropTypes.object
};

const mapStateToProps = (state) => {
  return {
    cachedRoute: getCachedRoutePath(state)
  };
};

export default connect(mapStateToProps)(props => (
  <SessionContext.Consumer>
    {session => <UnauthenticatedRoute {...props} session={session} />}
  </SessionContext.Consumer>
));
